import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';
import { nossFilter } from '../../../../../paws/assets/frontend/js/helper/filter';
import {changeToResponsiveImage} from "../../../../../paws/assets/frontend/js/helper/lazyinit";

whenDocumentReady(initModule);
function initModule() {
    let ease = {
        linear: t => t,
        inOutQuad: t => t<.5 ? 2*t*t : -1+(4-2*t)*t,
        // Find out more at: https://gist.github.com/gre/1650294
    };

    let counter = (EL) => {

        let from = parseInt(EL.dataset.from, 10); // Get start and end values
        let to = parseInt(EL.dataset.to, 10); // PS: Use always the radix 10!
        let duration = parseInt(EL.dataset.duration, 10); // Get start and end values
        let plus = parseInt(EL.dataset.plus,10); // Get start and end values
        let commafrom = parseInt(EL.dataset.commafrom, 10); // Get start and end values
        let commato = parseInt(EL.dataset.commato, 10); // PS: Use always the radix 10!
        let finalTo = to;
        let finalCommaTo = commato;

        if (from === to) return; // If equal values, stop here.

        if (from > to) {
            from = from - 1;

        }
        else {
            to = to + 1;
        }

        let useComma = false;
        if (!isNaN(commafrom) && !isNaN(commato)) {
            if (commafrom !== 0 || commato !== 0) {
                useComma = true;

                if (commafrom > commato) {
                    commafrom = commafrom - 1;
                } else {
                    commato = commato + 1;
                }
            }
        }

        let range = to - from; // Get the range
        let curr = from; // Set current at start position
        let commarange = commato - commafrom; // Get the range
        let commacurr = commafrom; // Set current at start position

        let timeStart = Date.now();

        let loop = () => {
            let elaps = Date.now() - timeStart;
            if (elaps > duration) {
                let endTo = '';
                if (useComma) {
                    endTo = Math.trunc(finalTo) + '.' + Math.trunc(finalCommaTo);
                }
                else {
                    endTo = Math.trunc(finalTo);
                }

                if (plus === 1) {
                    EL.textContent = endTo.toLocaleString('de-CH').replaceAll('\'', '’') + '+'; // Apply to UI as integer
                }
                else {
                    EL.textContent = endTo.toLocaleString('de-CH').replaceAll('\'', '’'); // Apply to UI as integer
                }
            }
            else {
                let norm = ease.inOutQuad(elaps / duration); // normalised value + easing
                let step = norm * range; // Calculate the value step
                let commastep = norm * commarange; // Calculate the value step
                curr = from + step; // Increment or Decrement current value
                commacurr = commafrom + commastep; // Increment or Decrement current value
                let newValue = 0;
                if (useComma) {
                    newValue = Math.trunc(curr) + '.' + Math.trunc(commacurr);
                } else {
                    newValue = Math.trunc(curr);
                }
                if (elaps < duration) {
                    EL.textContent = newValue.toLocaleString('de-CH').replaceAll('\'', '’'); // Apply to UI as integer
                    requestAnimationFrame(loop);
                } // Loop
                else {
                    if (plus === 1) {
                        EL.textContent = newValue.toLocaleString('de-CH').replaceAll('\'', '’') + '+'; // Apply to UI as integer
                    }
                }
            }
        };

        requestAnimationFrame(loop); // Start the loop!
    };

    let makeCountup = (el) => {
        const io = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    counter(el);
                    io.unobserve(entry.target);
                }
            });
        });

        io.observe(el);
    }

    document.querySelectorAll('[paws-component="noss-countup"][paws-template="default"] [data-from]').forEach(makeCountup);

}